import { openNotification } from "../globals/Components/Notification/Notificaction";
import validateMessages from "../globals/Inputs/validateMessages";
import { MessageResponse } from "./system/types";

const getErrorStatus = (responseData: any): number => responseData?.Error?.status || responseData?.StatusCode || 500;

const normalizeErrorMessage = (error: any): string => {
    const value = error?.message ?? error?.title ?? error?.error ?? error;

    if (!value) {
        return "No se pudo procesar la solicitud.";
    }

    if (typeof value === "string") {
        return value;
    }

    if (Array.isArray(value)) {
        return value.map((item) => normalizeErrorMessage(item)).join(", ");
    }

    if (typeof value === "object") {
        if (value.message || value.title || value.error) {
            return normalizeErrorMessage(value);
        }

        return Object.entries(value)
            .map(([key, item]) => `${key}: ${normalizeErrorMessage(item)}`)
            .join(", ");
    }

    return String(value);
};

export const serverMessages = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    const status = getErrorStatus(responseData);
    const errorMessage = normalizeErrorMessage(responseData?.Error);

    if (status !== 400) {       
        message = {
            code: status,
            message: [validateMessages.serverError+":"+ errorMessage]
        };
        openNotification("Error del sistema", validateMessages.serverError+":"+ errorMessage)      
        
    }
    else {        
        const errorResponse = errorMessage;        
        message = {
            code: status,
            message: [errorResponse]
        };     
        openNotification("Advertencia", errorResponse)        
    }
    return message;  
};

export const serverMessagesLogin = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    const status = getErrorStatus(responseData);
    const errorMessage = normalizeErrorMessage(responseData?.Error);
    
    if (status !== 400) {       
        message = {
            code: status,
            message: [validateMessages.serverError+":"+ errorMessage]
        };   
        
       
    }
    else {        
        const errorResponse = errorMessage;        
        message = {
            code: status,
            message: [errorResponse]
        };   
         if(errorMessage === "ERROR: Servidores no disponibles.")  {
            window.location.replace(process.env.REACT_APP_BASE_URL as string+"/error-server");
        }   
    }
    return message;  
};

export const serverMessagesNoOpenNotification = (responseData: any): MessageResponse=> {       
    let message: MessageResponse;
    const status = getErrorStatus(responseData);
    const errorMessage = normalizeErrorMessage(responseData?.Error);

    if (status !== 400) {       
        message = {
            code: status,
            message: ["Ups, algo no salió como esperábamos. Por favor, contacte al departamento de sistemas para que podamos ayudarle."]
        };        
    }
    else {        
        const errorResponse = errorMessage;        
        message = {
            code: status,
            message: [errorResponse]
        };                
        //openNotification("Advertencia", errorResponse)    
    }
    return message;  
};
